var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fa-secondary{opacity:.4}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 96C186.501 96 208.001 74.5 208.001 48S186.501 0 160 0S112 21.5 112 48S133.5 96 160 96Z",
    className: "fa-secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.126 271.047L253.938 173.094C236.251 144.859 205.813 128 172.531 128H147.469C114.187 128 83.749 144.859 66.061 173.125L4.873 271.047C-4.502 286.031 0.061 305.766 15.03 315.141C30.061 324.516 49.78 319.953 59.124 304.953L91.743 252.768L47.999 384H87.999V480C87.999 497.672 102.325 512 119.999 512S152 497.672 152 480V384H168V480C168 497.672 182.326 512 200 512S232.001 497.672 232.001 480V384H272.001L228.245 252.732L260.876 304.953C266.938 314.672 277.376 320 288.032 320C293.814 320 299.689 318.438 304.97 315.141C319.939 305.766 324.502 286.031 315.126 271.047Z",
    className: "fa-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.7a2d3058.svg";
export { ForwardRef as ReactComponent };